export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var btnName = $params.action;
  $params.btnDebounce(function() {
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给领导？', '提示', {type: 'info'}).then(() => {
      PF.api.process.getBindLeaderData($params.taskId).then(res=> {
        if(res.success) {
          var leadData = res.result;
          if(!leadData || !leadData.flow){
            PF.message('info', '获取领导数据信息失败!');
            return;
          }
          doCommit(leadData);
        }
      });
    }).catch(() => {
      $params.setBtnLoading(false, btnName);
    });
  });

  function doCommit(leadData){
      var p ={
        taskId:$params.taskId,
        appId:$params.appId,
        formId:$params.formId,
        formKey:$params.formKey
      }
     if($params.comment){
        p['$comment']=$params.comment;
      }
      p.type = "complete";
      p.actionDescription = '送领导';
      p['$directSave']=true;
      var flow = leadData.flow;
      if(flow){
        var activity={};
        activity.flowId=flow.id;
        activity.activityId=flow.activityId;
        activity.type=flow.type;
        activity.options=flow.options;
        var items=[];
        var item={};
        item.group=leadData.departmentId;
        item.users=[{id:leadData.id}];
        items.push(item);
        activity.items = items;
        p.activities=[activity];
      }
    if($params.extParams && $params.extParams.fullAuthType){
      p.fullAuthType = $params.extParams.fullAuthType;
    }
      PF.api.process.batchCommit(p).then(res => {
        if (res.success) {
          $params.formActionComplete(); //关闭窗口
        }
        $params.setBtnLoading(false, btnName);
      }).catch(() => {
       $params.setBtnLoading(false, btnName);
      });
    }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-spsendleader.js